import React from 'react';
import { motion } from 'framer-motion';
export function WhyDiagnosticMatters() {
  const models = ['Camry', 'Corolla', 'RAV4', 'RAV4 Hybrid', 'Prius', 'Tacoma', 'Tundra', 'Highlander', '4Runner', 'Sienna', 'Venza', 'Avalon'];
  const lexusModels = ['ES', 'IS', 'RX', 'NX', 'GX', 'LX'];
  return <section id="what-we-do" className="py-20 px-4 bg-white pt-[50px] pb-[50px]" data-id="element-251">
      <div className="max-w-5xl mx-auto" data-id="element-252">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center" data-id="element-253">
          <span className="uppercase tracking-widest text-sm font-bold text-brand-accent mb-4 block pt-[20px] pb-[20px]" data-id="element-254">
            Toyota familiarity built over decades
          </span>
          <h2 className="font-heading uppercase tracking-wide text-3xl md:text-4xl lg:text-5xl font-extrabold text-brand-dark mb-12" data-id="element-255">
            There's a difference between servicing a Toyota and really knowing
            one.
          </h2>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="space-y-6 text-lg md:text-xl text-gray-700 leading-relaxed text-center max-w-4xl mx-auto mb-16" data-id="element-256">
          <p className="pl-[0px] pr-[0px]" data-id="element-257">
            Any shop can change your oil. Fewer know that a high-mileage Tacoma
            has different priorities than a newer RAV4 Hybrid, or what tends to
            develop on a Corolla at 120,000 miles before it turns expensive.
          </p>

          <p data-id="element-258">
            We've been working on Toyotas long enough to know how these vehicles
            age, where they're strong, and where to look before something
            becomes expensive.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="bg-brand-light border border-gray-200 rounded-2xl p-8 md:p-10 shadow-sm max-w-4xl mx-auto text-center" data-id="element-259">
          <h3 className="font-heading uppercase tracking-wide text-xl font-bold text-brand-dark mb-6" data-id="element-260">
            We regularly service:
          </h3>
          <div className="flex flex-wrap justify-center gap-3 mb-8" data-id="element-261">
            {models.map((model, index) => <span key={index} className="bg-white border border-gray-200 text-brand-dark font-medium px-4 py-2 rounded-full shadow-sm" data-id="element-262">
                {model}
              </span>)}
          </div>

          {/* Lexus divider + row */}
          <div className="relative my-6" data-id="element-263">
            <div className="absolute inset-0 flex items-center" aria-hidden="true" data-id="element-264">
              <div className="w-full border-t border-gray-300" data-id="element-265" />
            </div>
            <div className="relative flex justify-center" data-id="element-266">
              <span className="bg-brand-light px-4 uppercase tracking-widest text-xs font-bold text-brand-accent" data-id="element-267">
                Also servicing Lexus
              </span>
            </div>
          </div>
          <div className="flex flex-wrap justify-center gap-3 mb-6" data-id="element-268">
            {lexusModels.map((model, index) => <span key={index} className="bg-white border border-gray-200 text-brand-dark font-medium px-4 py-2 rounded-full shadow-sm" data-id="element-269">
                {model}
              </span>)}
          </div>

          <p className="text-gray-500 font-medium" data-id="element-270">
            All makes and models 2007 and newer, including hybrids and EVs.
          </p>
        </motion.div>
      </div>
    </section>;
}